// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"ff7b84244c48b2c9a564","137":"ac94b9796cd9ebcd6f2d","138":"dbcc2446fb3eefd3e4e4","186":"09510b8a2e7acdd6759e"}[chunkId] + ".chunk.js";
};